import React from "react";
import Footer from "../Footer/Footer";
import JoinNowModal from "../JoinNowModal/JoinNowModal";
import Nav from "../Nav/Nav";
import PrivacyPolicy from "../PrivacyPolicy/PrivacyPolicy";

export default function PrivacyPage() {
    const [modalShow, setModalShow] = React.useState(false);

    return (

        <>
            <JoinNowModal  show={modalShow} onHide={() => setModalShow(false)} />
            <div id='home'>
                <Nav modalHandler={setModalShow} />
                <PrivacyPolicy />
                <Footer />
            </div>
        </>


    );
}
